























































































































































































import {
  computed,
  defineComponent, onMounted, reactive, Ref, ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getPurchaseOrders,

  getMaterials,
  getPurchaseOrderStats,
  updatePurchaseOrder,
} from '@/api';
import useAuth from '@/use/useAuth';
import { Material } from '@/types/material';
import purchaseOrderTableOption from '@/table/PurchaseOrder/purchase-order';
import usePurchaseOrder from '@/use/usePurchaseOrder';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithPurchaseOrderInfo from '@/components/PurchaseOrder/CommonModalWithPurchaseOrderInfo.vue';
import PanelWithPurchaseOrderItemTable from '@/components/PurchaseOrder/PanelWithPurchaseOrderItemTable.vue';
import CommonFormWithTargetDateUpdater from '@/components/PurchaseOrder/CommonFormWithTargetDateUpdater.vue';
import CommonModalWithApprovePurchaseOrder from '@/components/PurchaseOrder/CommonModalWithApprovePurchaseOrder.vue';
import useDownloadReport from '@/use/useDownloadReport';

const defaultFilter = {
  searchString: '',
  status: '',
  job_no: '',
  materials: [],
  date: undefined,
  approved: '',
  manager_approved: '',
  chief_manager_approved: '',
};

const List = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithPurchaseOrderInfo,
    PanelWithPurchaseOrderItemTable,
    CommonFormWithTargetDateUpdater,
    CommonModalWithApprovePurchaseOrder,
  },
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    const { getReport } = useDownloadReport();
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }

    const { en: statusList, th: statusDisplay } = usePurchaseOrder();
    const getMaterialsResult = (data: any) => data.data.data;
    const viewPurchaseOrderModal = ref(null);
    const approvePurchaseOrderModal = ref(null);
    const refetchUnreceiveItemsQuery = ref(false);
    const refetchItemsQuery = ref(false);
    const refetchQuery = ref(false);
    const currentTab = ref('po-list');
    const pendingSearch = _.debounce(() => {
      if (currentTab.value === 'material' || currentTab.value === 'unreceive-material') refetchItemsQuery.value = true;
      else refetchQuery.value = true;
    }, 250);
    const filter = reactive(defaultFilter);
    function tabChangeHandler(tabName: string) {
      currentTab.value = tabName;
      filter.searchString = '';
      filter.job_no = '';
      filter.status = '';
      filter.materials = [];
      filter.date = undefined;
      filter.approved = '';
      filter.manager_approved = '';
      filter.chief_manager_approved = '';
      pendingSearch();
    }
    const stats = reactive({
      total: 0,
      waiting: 0,
      done: 0,
      cancelled: 0,
    });
    async function getStats() {
      const result = await getPurchaseOrderStats({ date: filter.date });
      stats.total = result.total;
      stats.waiting = result.waiting;
      stats.done = result.done;
      stats.cancelled = result.cancelled;
    }

    function clickDateHandler(date: any) {
      if (filter.date === useFormat.date(date).computerShortDate()) {
        filter.date = undefined;
      } else {
        filter.date = useFormat.date(date).computerShortDate();
      }
      pendingSearch();
    }
    const computedFilter = computed(() => {
      const output: { [key: string]: any } = {
        code: filter.searchString,
        status: filter.status,
        transactionDate: filter.date,
        job_no: filter.job_no,
        approved: undefined,
        manager_approved: undefined,
        chief_manager_approved: undefined,
      };
      if (currentTab.value === 'material' || currentTab.value === 'unreceive-material') {
        if (filter.materials.length > 0) output.filterMaterials = filter.materials.map((material: Material) => material.id);
        output.filterTargetDate = filter.date;
      } else {
        output.updated_at = filter.date;
      }
      if (currentTab.value === 'po-list') {
        if (filter.approved) output.approved = filter.approved;
        if (filter.manager_approved) output.manager_approved = filter.manager_approved;
        if (filter.chief_manager_approved) output.chief_manager_approved = filter.chief_manager_approved;
      }
      return output;
    });

    const onRowClick = (row: { item: { id: number } }) => {
      (viewPurchaseOrderModal.value as any).open(row.item.id);
    };

    onMounted(async () => {
      await getStats();
    });

    const cancelPoModal = ref(null);
    async function updatePurchaseOrderStatusHandler(ctx: any) {
      await updatePurchaseOrder(ctx.id, { status: ctx.status });
      refetchQuery.value = true;
      refetchItemsQuery.value = true;
    }

    // use to update Target date
    const showRightPanel = ref(false);
    const updateTargetDateItem: Ref<any> = ref({ data: { id: -1 } });
    function pendingUpdateTargetDate(option: any) {
      if (updateTargetDateItem.value.data?.id === option.data.id && updateTargetDateItem.value.type === option.type) {
        showRightPanel.value = false;
        updateTargetDateItem.value = { data: { id: -1 }, type: '' };
      } else {
        showRightPanel.value = true;
        updateTargetDateItem.value = option;
      }
    }

    function openApprovalModal(po: any, level: string) {
      (approvePurchaseOrderModal.value as any).open(po);
    }

    return {
      toCurrencyWithoutSign,
      hasPermission,
      getReport,

      currentTab,
      tabChangeHandler,

      getMaterials,
      getMaterialsResult,

      statusList,
      statusDisplay,
      stats,
      filter,
      computedFilter,
      clickDateHandler,

      viewPurchaseOrderModal,

      getPurchaseOrders,
      purchaseOrderTableOption,
      onRowClick,

      updatePurchaseOrderStatusHandler,
      cancelPoModal,

      pendingSearch,
      refetchQuery,
      refetchItemsQuery,

      showRightPanel,
      updateTargetDateItem,
      pendingUpdateTargetDate,

      refetchUnreceiveItemsQuery,

      approvePurchaseOrderModal,
      openApprovalModal,
    };
  },
});

export default List;
